import { buildAppCanvasUrl } from "@/public-canvas/appCanvasUrl";
import type { CanvasEntity, Entity } from "@cohesive/api-entities";
import { isCanvasLinkEntity } from "@cohesive/ui-components";

export { isCanvasLinkEntity };

/**
 * Entity for a canvas placed on another canvas. Reference-only by design: the
 * node stores id + name and the card hydrates hero / location live, so a copy
 * of the canvas never exists inside a node.
 */
export function buildCanvasLinkEntity(canvas: {
  id: string;
  name?: string | null;
  workspace_id?: string | null;
}): CanvasEntity {
  return {
    type: "canvas",
    platform: "cohesive",
    data: {
      id: canvas.id,
      name: canvas.name ?? "",
      ...(canvas.workspace_id ? { workspace_id: canvas.workspace_id } : {}),
    },
  };
}

/** The linked canvas's id when `entity` is a canvas link, else null. */
export function canvasLinkTargetId(
  entity: Entity | null | undefined,
): string | null {
  return entity && isCanvasLinkEntity(entity) ? entity.data.id : null;
}

/** App URL the card opens (always a new tab). */
export function canvasLinkOpenUrl(entity: CanvasEntity): string {
  return buildAppCanvasUrl(entity.data.id);
}
